import {
    Component,
} from '@angular/core';
import {
    AbstractControl,
    UntypedFormControl,
    UntypedFormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators
} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {NgxSpinnerService} from "ngx-spinner";
import {AppService} from "@services/app.service";
import {Subject, takeUntil} from 'rxjs';
import {Router} from "@angular/router";

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
    destroy$: Subject<boolean> = new Subject<boolean>();
    isOTPSent: boolean = false;
    isPasswordVisible: boolean = false;
    isConfirmPasswordVisible: boolean = false;

    constructor(private toastr: ToastrService, private spinner: NgxSpinnerService, private appService: AppService,
                private router: Router,) {

    }


    PasswordsMatchValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const password = control.get('password')?.value;
            const confirmPassword = control.get('confirmPassword')?.value;

            if (password !== confirmPassword) {
                return {passwordsMismatch: true};
            }
            return null;
        };
    }


    forgotPasswordForm = new UntypedFormGroup({
        emailId: new UntypedFormControl("", [Validators.required, Validators.nullValidator, Validators.email]),
        phoneNumber: new UntypedFormControl('', [
            Validators.required,
            Validators.minLength(10),
            Validators.maxLength(10),
            Validators.pattern('^[0-9]{10}$')
        ]),
        verificationOtp: new UntypedFormControl("", [Validators.required, Validators.nullValidator]),
        password: new UntypedFormControl("", [Validators.required, Validators.minLength(4)]),
        confirmPassword: new UntypedFormControl("", [Validators.required]),
    }, {
        validators: this.PasswordsMatchValidator()
    })


    public forgetPasswordError = {
        emailId: '',
        phoneNumber: '',
        verificationOtp: '',
        password: '',
        confirmPassword: ''
    }


    onSubmit() {
        this.formValidation();
    }

    formValidation() {
        this.forgetPasswordError = {
            emailId: '',
            phoneNumber: '',
            verificationOtp: '',
            password: '',
            confirmPassword: ''
        };
        let hasError = false;

        const emailControl = this.forgotPasswordForm.get("emailId");
        const phoneControl = this.forgotPasswordForm.get("phoneNumber");
        const otpControl = this.forgotPasswordForm.get("verificationOtp");
        const passwordControl = this.forgotPasswordForm.get("password");
        const confirmPasswordControl = this.forgotPasswordForm.get("confirmPassword");

        // Email is always required
        if (emailControl?.invalid) {
            this.forgetPasswordError.emailId = "Registered Email is Required";
            hasError = true;
        }

        if (this.isOTPSent) {
            if (phoneControl?.invalid) {
                this.forgetPasswordError.phoneNumber = "Registered Phone Number is Required";
                hasError = true;
            }

            if (otpControl?.invalid) {
                this.forgetPasswordError.verificationOtp = "Enter the OTP sent to your email. This field is required";
                hasError = true;
            }

            if (passwordControl?.invalid) {
                this.forgetPasswordError.password = "Enter your new password";
                hasError = true;
            }

            if (confirmPasswordControl?.invalid) {
                this.forgetPasswordError.confirmPassword = "Confirm your new password";
                hasError = true;
            }

            if (this.forgotPasswordForm.errors?.passwordsMismatch) {
                this.forgetPasswordError.confirmPassword = "Passwords do not match";
                hasError = true;
            }
        }

        // Execution logic
        if (!hasError) {
            if (!this.isOTPSent) {
                // Case 1: First time Send OTP
                this.sendOTP();
            } else {
                // All required fields are filled correctly
                this.verifyOTP();
            }
        }
    }


    OnlyNumbers($event) {
        let regex: RegExp = new RegExp(/^[0-9]{1,}$/g);
        let specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowRight', 'ArrowLeft'];
        if (specialKeys.indexOf($event.key) !== -1) {
            return;
        } else {
            if (regex.test($event.key)) {
                return true;
            } else {
                return false;
            }
        }
    }

    toggleConfirmPasswordVisibility() {
        const passwordShow = document.getElementById('confirmPassword') as HTMLInputElement;
        if (passwordShow.type == 'password') {
            passwordShow.type = 'text';
        } else {
            passwordShow.type = 'password';
        }
        this.isConfirmPasswordVisible = !this.isConfirmPasswordVisible;
    }

    togglePasswordVisibility() {
        const passwordShow = document.getElementById('password') as HTMLInputElement;
        if (passwordShow.type == 'password') {
            passwordShow.type = 'text';
        } else {
            passwordShow.type = 'password';
        }
        this.isPasswordVisible = !this.isPasswordVisible;
    }


    sendOTP() {

        const emailId = this.forgotPasswordForm.get('emailId').value;
        const otpName = {
            username: emailId
        }

        console.log(`otp::`, otpName);
        this.spinner.show();
        this.appService.sendOTPDetails(otpName)
            .pipe(takeUntil(this.destroy$))
            .subscribe((otp) => {
                this.spinner.hide();
                console.log(otp);
                this.isOTPSent = true;
                this.toastr.success(`We’ve sent an OTP to your email: ${emailId}. Please check your inbox.`);
            }, (error: any) => {
                console.log("error:", error);
                this.spinner.hide();
                if (error && error.error && error.error.msg) {
                    this.toastr.error(error.error.msg);
                } else {
                    this.toastr.error("Something went wrong, please try again");
                }
            });
    }

    verifyOTP() {
        console.log(this.forgotPasswordForm.value);
        const {confirmPassword, ...payload} = this.forgotPasswordForm.value;
        console.log(payload);
        this.spinner.show();
        this.appService.updatePasswordWithOTP(payload)
            .pipe(takeUntil(this.destroy$))
            .subscribe((otp) => {
                this.spinner.hide();
                console.log(otp);
                this.isOTPSent = true;
                this.toastr.success(`Your password updated successfully`);
                this.forgotPasswordForm.reset();
                this.router.navigate(['/login']);
            }, (error: any) => {
                console.log("error:", error);
                this.spinner.hide();
                if (error && error.error && error.error.msg) {
                    this.toastr.error(error.error.msg);
                } else {
                    this.toastr.error("Something went wrong, while updating password you may try again later");
                }
            });
    }
}
